import { apiUrl } from "../config/api";
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import "./Login.mobile.css";

const Login = () => {
	const [formData, setFormData] = useState({ username: "", password: "" });
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);
	const navigate = useNavigate();

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
		if (error) setError(null);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (isLoading) return;
		setIsLoading(true);
		setError(null);

		try {
			const response = await axios.post(
				apiUrl("/api/dashboard/login/"),
				formData
			);
			localStorage.setItem("accessToken", response.data.tokens.access);
			localStorage.setItem("refreshToken", response.data.tokens.refresh);
			navigate("/adminHome", { replace: true });
		} catch (err) {
			const data = err.response?.data;
			if (data) {
				const firstField = Object.keys(data)[0];
				const msgs = data[firstField];
				setError(Array.isArray(msgs) ? msgs[0] : String(msgs));
			} else {
				setError("Connection failed. Try again.");
			}
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="login-page">

			{/* ── LEFT PANEL: Branding ── */}
			<aside className="login-branding" aria-hidden="true">
				<div className="login-branding__top">
					<p className="login-branding__label">System Access</p>
					<h1 className="login-branding__headline">
						ENTER
						<span>THE</span>
						SYSTEM
					</h1>
					<div className="login-branding__divider" />
					<p className="login-branding__tagline">
						No credentials, no entry.<br />
						No exceptions. No second chances.
					</p>
				</div>
				<div className="login-branding__bottom">
					<span className="login-branding__footer-label">
						© {new Date().getFullYear()} — Restricted Area
					</span>
				</div>
				<span className="login-branding__deco" aria-hidden="true">01</span>
			</aside>

			{/* ── RIGHT PANEL: Form ── */}
			<main className="login-form-panel">

				<div className="login-form-panel__header">
					<p className="login-form-panel__eyebrow">Authentication</p>
					<h2 className="login-form-panel__title">Sign In</h2>
				</div>

				{error && (
					<div className="login-message login-message--error" role="alert">
						✕ &nbsp;{error}
					</div>
				)}

				<form className="login-form" onSubmit={handleSubmit} noValidate>

					<div className="login-field">
						<label className="login-field__label" htmlFor="username">Username</label>
						<input
							className="login-field__input"
							id="username"
							type="text"
							name="username"
							value={formData.username}
							onChange={handleChange}
							placeholder="your_handle"
							autoComplete="username"
							required
						/>
					</div>

					<div className="login-field">
						<label className="login-field__label" htmlFor="password">Password</label>
						<input
							className="login-field__input"
							id="password"
							type="password"
							name="password"
							value={formData.password}
							onChange={handleChange}
							placeholder="••••••••"
							autoComplete="current-password"
							required
						/>
					</div>

					<div className="login-submit-row">
						<button className="login-submit-btn" type="submit" disabled={isLoading}>
							{isLoading ? (
								<span className="login-submit-btn__spinner" aria-hidden="true" />
							) : (
								<>Access Now <span className="login-submit-btn__arrow">→</span></>
							)}
						</button>
					</div>

				</form>

				<div className="login-form-panel__meta">
					<div className="login-form-panel__meta-line" />
					<span className="login-form-panel__meta-text">Secure connection</span>
					<div className="login-form-panel__meta-line" />
				</div>

			</main>
		</div>
	);
};

export default Login;